<template lang="pug">
transition(name="fade")
  header(v-if="Initialized")
    router-link.logo-image(to="/")
      img(src='../assets/logo.png', v-if="!popupShow")
      img(src='../assets/header_logo_white.png', v-if="popupShow")
      //- img(src='../assets/logo.png', v-if="!TryScroll() && !popupShow")
      //- img(src='../assets/header_logo_white.png', v-if="TryScroll() || popupShow")
    .header-btn
      button.button-menu(v-on:click="ShowPopup(!popupShow)" :class="popupShow ? 'is-close' : 'is-open'")
        span.line.is-one
        span.line.is-two
        span.line.is-three
</template>

<script>
export default {
  props: {
    loadingEnd: Boolean,
    popupShow: Boolean,
    scrollY: Number,
  },
  computed: {
    Initialized:{
      get: function() {
        return this.loadingEnd
      }
    },
    IsPopupShow: {
      get: function() {
        console.log("this.popupShow " + this.popupShow)
        return this.popupShow
      }
    },
    ScrollY: {
      get: function() {
        console.log(this.scrollY)
        return this.scrollY
      }
    }
  },
  methods:{
    ShowPopup: function(value) {
      this.$emit('update-popupshow', value)
    },
    TryScroll: function() {
      return this.scrollY > 470
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes bounce-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

// .fade-enter-active, .fade-leave-active {
//   transition: opacity 1s;
// }

.fade-enter-active {
  animation: bounce-in 0.5s;
  // opacity: 0;
}

// .fade-enter-to, .fade-leave {
//   animation: bounce-in 1s;
//   // opacity: 1;
// }

header {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 67px;
  padding: 8px 12px;
  box-sizing: border-box;
  z-index: 101;
  .logo-image {
    width: 90px;
    transform-origin: left top;
    > img {
      width: 100%;
    }
  }

  .header-btn {

  }

  .button-reserve {
    display: block;
    position: absolute;
    width: 58px;
    height: 58px;
    line-height: 56px;
    right: 64px;
    top: 0;
    background: #2f1d0d;
    text-decoration: none;
    font-size: 14px;
  }

  .button-menu {
    position: absolute;
    width: 64px;
    height: 58px;
    right: 0;
    top: 0;
    transform: scale(1);
    background: #000;
    > .line {
      position: absolute;
      left: 50%;
      height: 1px;
      background: #fff;
      transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
    }
    &.is-open {
      > .line {
        margin-left: -14px;
        width: 28px;
        &.is-one {
          top: 35%;
        }
        &.is-two {
          top: 50%;
        }
        &.is-three {
          top: 65%;
        }
      }
    }
    &.is-close {
      > .line {
        top: 50%;
        width: 32px;
        &.is-one {
          transform: translate(-50%) rotate(45deg);
        }
        &.is-two {
          transform: translate(-50%) rotate(-45deg);
        }
        &.is-three {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Header.vue